module.exports = __webpack_public_path__ + "static/img/doncuco.9d1db9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/doncuco.png
// module id = sOiF
// module chunks = 0